"use strict";
// Copyright © Veeam Software Group GmbH
Object.defineProperty(exports, "__esModule", { value: true });
exports.typographyTokens = void 0;
const GlobalDesignToken_1 = require("../../types/GlobalDesignToken");
const fontFamily = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'fontFamily',
    fallback: '"Open Sans", sans-serif'
});
const fontSizeS = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'fontSize-s',
    fallback: '12px'
});
const fontSizeM = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'fontSize-m',
    fallback: '14px'
});
const fontSizeL = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'fontSize-l',
    fallback: '16px'
});
const fontSizeXL = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'fontSize-xl',
    fallback: '20px'
});
const fontSizeTitle3 = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'fontSize-title3',
    fallback: '24px'
});
const fontSizeTitle2 = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'fontSize-title2',
    fallback: '32px'
});
const fontSizeTitle1 = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'fontSize-title1',
    fallback: '40px'
});
const fontSizeDisplay = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'fontSize-disaply',
    fallback: '68px'
});
const lineHeightS = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'lineHeight-s',
    fallback: '16px'
});
const lineHeightM = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'lineHeight-m',
    fallback: '20px'
});
const lineHeightL = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'lineHeight-l',
    fallback: '22px'
});
const lineHeightXL = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'lineHeight-xl',
    fallback: '26px'
});
const lineHeightTitle3 = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'lineHeight-title3',
    fallback: '32px'
});
const lineHeightTitle2 = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'lineHeight-title2',
    fallback: '40px'
});
const lineHeightTitle1 = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'lineHeight-title1',
    fallback: '52px'
});
const lineHeightDisplay = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'lineHeight-display',
    fallback: '92px'
});
const fontWeightLight = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'fontWight-light',
    fallback: '300'
});
const fontWeightRegular = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'fontWight-regular',
    fallback: '400'
});
const fontWeightMedium = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'fontWight-medium',
    fallback: '500'
});
const fontWeightSemiBold = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'fontWight-semiBold',
    fallback: '600'
});
const fontWeightBold = new GlobalDesignToken_1.GlobalDesignToken({
    name: 'fontWight-bold',
    fallback: '700'
});
exports.typographyTokens = {
    fontFamily,
    fontSizeS,
    fontSizeM,
    fontSizeL,
    fontSizeXL,
    fontSizeTitle3,
    fontSizeTitle2,
    fontSizeTitle1,
    fontSizeDisplay,
    lineHeightS,
    lineHeightM,
    lineHeightL,
    lineHeightXL,
    lineHeightTitle3,
    lineHeightTitle2,
    lineHeightTitle1,
    lineHeightDisplay,
    fontWeightLight,
    fontWeightRegular,
    fontWeightMedium,
    fontWeightSemiBold,
    fontWeightBold
};
//# sourceMappingURL=Typography.js.map